<template>
  <AppHeader>Create Sample Request</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="p-3 text-gray-600 bg-white shadow rounded-2xl">
      <div class="px-2 py-1 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Name</p>
        <input v-model="form.name" ref="inputName" class="w-full text-xl placeholder:text-lg" placeholder="Enter Customer name" type="text">
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.name">{{ errors.name }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Phone Number</p>
        <input v-model="form.phone" class="w-full text-xl placeholder:text-lg" placeholder="Enter Phone (without +91)" type="number">
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.phone">{{ errors.phone }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Type</p>
        <select v-model="form.address.type" class="w-full text-xl bg-white">
          <option value="">-- Select Type --</option>
          <option v-for="type in address_types" :key="type" :value="type">{{ type }}</option>
        </select>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors['address.type']">{{ errors['address.type'] }}</p>
      </div>

      <div v-if="form.address.type === 'house'" class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">House No</p>
        <input v-model="form.address.house_no" class="w-full text-xl placeholder:text-lg" placeholder="Enter House No" type="text">
      </div>

      <div v-if="form.address.type === 'apartment'">
        <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
          <p class="text-gray-600">Apartment</p>
          <input v-model="form.address.apartment_name" class="w-full text-xl placeholder:text-lg" placeholder="Enter Apartment Name" type="text">
        </div>
        <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
          <p class="text-gray-600">Block Name</p>
          <input v-model="form.address.block_name" class="w-full text-xl placeholder:text-lg" placeholder="Enter Block / Floor" type="text">
        </div>
        <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
          <p class="text-gray-600">Door No</p>
          <input v-model="form.address.door_no" class="w-full text-xl placeholder:text-lg" placeholder="Enter Door No" type="text">
        </div>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Address</p>
        <textarea v-model="form.address.address" class="w-full text-xl placeholder:text-lg" placeholder="Enter Full Address"></textarea>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Area</p>
        <select v-model="form.area_id" class="w-full text-xl bg-white" @change="updatedArea">
          <option value="">-- Select Area --</option>
          <option v-for="area in areas" :key="area.id" :value="area.id">{{ area.name }}</option>
        </select>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.area_id">{{ errors.area_id }}</p>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.district_id">{{ errors.district_id }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Source</p>
        <select v-model="form.from" class="w-full text-xl bg-white">
          <option value="">-- Select Source --</option>
          <option>Public Place Stall</option>
          <option>Appartment Event</option>
          <option>Customer Reference</option>
          <option>During Delivery</option>
          <option>Other</option>
        </select>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.from">{{ errors.from }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Location</p>
        <div class="flex justify-between">
          <input v-model="form.latitude" class="w-full text-xl placeholder:text-lg" placeholder="Latitude" type="number">
          <input v-model="form.longitude" class="w-full text-xl placeholder:text-lg" placeholder="Longitude" type="number">
          <button class="px-3 py-1 ml-2 text-lg leading-none rounded bg-slate-200" @click="getLocation">
            <i class="ion-md-pin"></i>
          </button>
        </div>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">House Image <span class="text-sm text-gray-400">(Optional)</span></p>
        <input type="file" accept="image/jpg,image/jpeg,image/png" @change="onFileChange('house_image', $event)" class="mt-2 outline-none W-full text-slate-400 file:border-none file:rounded-full file:leading-none file:p-2">
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.house_image">{{ errors.house_image }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Drop-off Point <span class="text-sm text-gray-400">(Optional)</span></p>
        <input type="file" accept="image/jpg,image/jpeg,image/png" @change="onFileChange('dropoff_point', $event)" class="mt-2 outline-none W-full text-slate-400 file:border-none file:rounded-full file:leading-none file:p-2">
      <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.dropoff_point">{{ errors.dropoff_point }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Notes</p>
        <textarea v-model="form.notes" class="w-full text-xl placeholder:text-lg" placeholder="Any extra notes"></textarea>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.notes">{{ errors.notes }}</p>
      </div>
    </div>

    <div class="mt-5 text-center">
      <button class="px-3 py-2 text-sm leading-none text-gray-600 uppercase rounded-full bg-slate-300" @click="createSample">Create Sample</button>
    </div>
  </div>
</template>

<script>
import { Geolocation } from '@capacitor/geolocation';
import mixin from '@/utils/mixin.js';
import formMixin from '@/utils/mixins/form';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';

export default {
  name: 'CreateLead',
  mixins: [ mixin, formMixin ],
  components: { AppHeader, Loading },
  data() {
    return {
       state: 'loading',
      areas: [],
      address_types: [],
      files: { house_image: null, dropoff_point: null },
      form: { district_id: '', area_id: '', from: '',  name: '', phone: '', address: { type: '', house_no: '', door_no: '', apartment_name: '', block_name: '', address: '' },},
    };
  },

  methods: {
    getData() {
      this.state = 'loading';

      this.request('GET', 'leads/prepare', {}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.areas = resp.data.areas;
          this.address_types = resp.data.address_types;
          this.$nextTick(() => {
            this.$refs.inputName.focus();
          });
        } else alert(resp.message);
      });
    },

    updatedArea() {
      this.form.district_id = this.areas.filter(a => a.id = this.form.area_id)[0].district_id;
    },

    onFileChange(field, event) {
      const file = event.target.files[0];

      if (!file) return;

      const isValidSize = file.size <= 2 * 1024 * 1024;
      const isValidType = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);

      if (!isValidSize) { this.errors[field] = 'File size must be under 2MB'; return; }
      if (!isValidType) { this.errors[field] = 'Only JPG, JPEG, PNG allowed'; return; }

      this.errors[field] = null;
      this.files[field] = file;
    },

    createSample() {
      let validationRules = {
        name: 'required|notempty',
        phone: 'required|numeric|length:10',
        area_id: 'required|numeric',
        district_id: 'required|numeric',
        from: 'required|notempty',
      };

      if (!this.validateForm(this.form, validationRules)) return;

      if (!this.form.address.type) { alert('Address Type is required'); return;}
      if (this.form.address.type === 'house' && !this.form.address.house_no) { alert('House No is required'); return;}
      if (this.form.address.type === 'apartment') {
        if (!this.form.address.apartment_name) { alert('Apartment Name is required'); return; }
        if (!this.form.address.block_name) { alert('Block Name is required'); return; }
        if (!this.form.address.door_no) { alert('Door No is required'); return; }
      }
      if (!this.form.address.address) { alert('Address is required'); return; }

      this.state = 'loading';
      this.form.dealer_id = this.$store.state.user.id;

      let address_json = { type: this.form.address.type, address: this.form.address.address };

      if (this.form.address.type === 'house') {
        address_json.house_no = this.form.address.house_no;
      } else if (this.form.address.type === 'apartment') {
        address_json.door_no = this.form.address.door_no;
        address_json.apartment_name = this.form.address.apartment_name;
        address_json.block_name = this.form.address.block_name;
      }

      const { address, ...rest } = this.form;

      const formData = new FormData();
      Object.entries({ ...rest, address_json: JSON.stringify(address_json) }).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
          formData.append(key, value);
        }
      });
      if (this.files.house_image) formData.append('house_image', this.files.house_image);
      if (this.files.dropoff_point) formData.append('dropoff_point', this.files.dropoff_point);

      this.request('POST', 'leads-new', formData, (resp) => {
        this.state = 'idle';
        alert(resp.message);

        if (resp.success) {
          this.form = { district_id: '', area_id: '', from: this.form.from, address: { type: '', house_no: '', door_no: '', apartment_name: '', block_name: '', address: '' }};
          this.files = { house_image: null, dropoff_point: null };
        }
      });
    },

    getLocation() {
      this.checkPermission();
    },

    checkPermission() {
      Geolocation
        .checkPermissions()
        .then(e => {
          if (e.location != 'granted' && this.$store.state.platform != 'web') {
            Geolocation
              .requestPermissions('location')
              .then(this.getCurrentLocation)
              .catch(e => alert('Please check if GPS is turned On!'));
          } else {
            this.getCurrentLocation();
          }
        })
        .catch(e => alert('Please check if GPS is turned On!'));
    },

    getCurrentLocation() {
      Geolocation
        .getCurrentPosition({enableHighAccuracy: true})
        .then(pos => {
          this.form.latitude = pos.coords.latitude;
          this.form.longitude = pos.coords.longitude;
        })
        .catch(e => alert('Please check if GPS is turned On!'));
    },
  },

  created() {
    this.getData();
  },
}
</script>
